import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import CommentIcon from "@mui/icons-material/Comment";
import { DocumentItemStyles } from "./GenericOrderInfoStyles";
import EditIcon from "@mui/icons-material/Edit";
import { DeletePopup } from "@Components/Popup/DeletePopup";
import useDeleteItem from "../../Hooks/useDeleteItem";
import DeleteIcon from "@mui/icons-material/Delete";
import MeatballsMenu from "@Components/MeatballsMenu/MeatballsMenu";
import { useState } from "react";
import { EditSectionPopup } from "../GenericForm/EditSectionPopup";
import useSendPutRequest from "@Hooks/useSendPutRequest";
import { SAVE_DOCUMENT, DOCUMENTS_URL } from "../../API/APIRoutes";
import axios from "axios";
import { useEffect } from "react";
import usePostItem from "@Hooks/usePostItem";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { formatDateUTC } from "../../Utils/Validations/HelperFunctions/FormaterFunctions";
import {
  inputTypes,
  cargoxNames,
  cargoxStatuses,
} from "../../Utils/HelpingObjects/HelpingObjects";
import { CARGOX_URL } from "../../API/APIRoutes";

export default function DocumentList({
  orderId,
  documents: initialDocuments,
  selectedObject,
  setSelectedObject,
  cargoXs: initialCargoXs,
  editable,
}) {
  const [documents, setDocuments] = useState(initialDocuments || []);
  const [showEditDocumentPopup, setShowEditDocumentPopup] = useState(false);
  const [showEditCargoXPopup, setShowEditCargoXPopup] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [selectedCargoX, setSelectedCargoX] = useState(null);
  const [cargoXWithoutDoc, setCargoXWithoutDoc] = useState(null);

  const { isLoading: PutItemLoading, requestMethod: putItem } =
    useSendPutRequest();

  const { postItem: insertDocument } = usePostItem();
  const [insertDocumentLoading, setInsertDocumentLoading] = useState(false);

  useEffect(() => {
    setDocuments(initialDocuments || []);
  }, [initialDocuments]);

  useEffect(() => {
    setCargoXWithoutDoc(
      initialCargoXs?.filter(
        (c) =>
          !documents.some(
            (d) =>
              d?.documentName?.replace(/_/g, " ") ===
              c?.cargoXName?.replace(/_/g, " ")
          )
      ) || []
    );
  }, []);

  const PfiFormFields = [
    {
      size: 12,
      type: inputTypes.TEXT,
      key: "documentName",
      label: "Document Name",
      editable: false,
    },
    {
      size: 12,
      type: inputTypes.DATE,
      key: "softCopyReceivalDate",
      label: "PFI Received Date",
      editable: true,
    },
  ];
  const documentformFields = [
    {
      size: 12,
      type: inputTypes.TEXT,
      key: "documentName",
      label: "Document Name",
      editable: false,
    },
    {
      size: 12,
      type: inputTypes.DATE,
      key: "softCopyReceivalDate",
      label: "Soft Copy Received Date",
      editable: true,
    },
    {
      size: 12,
      type: inputTypes.DATE,
      key: "hardCopyReceivalDate",
      label: "Hard Copy Received Date",
      editable: true,
    },
    {
      size: 12,
      type: inputTypes.TEXT,
      key: "comment",
      label: "Comment",
      editable: true,
    },
    {
      size: 4,
      type: inputTypes.BOOLEAN,
      key: "correct",
      label: "Correct",
      editable: true,
    },
    {
      size: 4,
      type: inputTypes.BOOLEAN,
      key: "softCopy",
      label: "Soft Copy",
      editable: true,
    },
    {
      size: 4,
      type: inputTypes.BOOLEAN,
      key: "hardCopy",
      label: "Hard Copy",
      editable: true,
    },
  ];
  const cargoXformFields = [
    {
      size: 12,
      type: inputTypes.SEARCHABLE_DROPDOWN,
      key: "cargoXName",
      label: "CargoX Name",
      options: cargoxNames,
      editable: false,
    },
    {
      size: 12,
      type: inputTypes.SEARCHABLE_DROPDOWN,
      key: "cargoXStatus",
      label: "CargoX Status",
      options: cargoxStatuses,
      editable: true,
    },
    {
      size: 12,
      type: inputTypes.DATE,
      key: "cargoXUploadDate",
      label: "Upload Date",
      editable: true,
    },
    {
      size: 12,
      type: inputTypes.TEXT,
      key: "comment",
      label: "Comment",
      editable: true,
    },
  ];

  const formatDate = (date) => {
    if (!date) return null;
    return typeof date.toDate === "function" ? date.toDate() : date;
  };
  const onEditDocument = (document) => {
    setSelectedDocument(document);
    setShowEditDocumentPopup(true);
  };
  const onEditCargoX = (cargoX) => {
    setSelectedCargoX(cargoX);
    setShowEditCargoXPopup(true);
  };
  const closeEditDocumentPopup = () => setShowEditDocumentPopup(false);
  const closeEditCargoxPopup = () => setShowEditCargoXPopup(false);

  const confirmEditDocument = async (newDocumentData, file) => {
    setInsertDocumentLoading(true);
    const processedData = {
      ...newDocumentData,
      softCopyReceivalDate: formatDate(newDocumentData.softCopyReceivalDate),
      hardCopyReceivalDate: formatDate(newDocumentData.hardCopyReceivalDate),
      fileAttached: file ? true : false,
      orderId: Number(orderId),
    };
    const PfiProcessedData = {
      ...newDocumentData,
      softCopyReceivalDate: formatDate(newDocumentData.softCopyReceivalDate),
      fileAttached: file ? true : false,
      orderId: Number(orderId),
    };
    const response = await insertDocument(
      SAVE_DOCUMENT,
      newDocumentData.documentName === "PFI" ? PfiProcessedData : processedData,
      () => {},
      `Document Updated Successfully!`,
      `Failed to update Document!`
    );
    if (!response) return;
    // Extract preSignedUrl and objectKey outside the .then()
    if (file && response?.preSignedUrl) {
      const { preSignedUrl, objectKey } = response;
      // Upload file to Minio
      await axios.put(preSignedUrl, file, {
        headers: {
          "Content-Type": "application/pdf",
        },
      });
    }
    const updatedDocuments = documents.map((doc) =>
      doc.documentId === newDocumentData.documentId
        ? newDocumentData.documentName === "PFI"
          ? PfiProcessedData
          : processedData
        : doc
    );
    setDocuments(updatedDocuments);
    setSelectedObject(
      newDocumentData.documentName === "PFI" ? PfiProcessedData : processedData
    );

    // reload page
    window.location.href = window.location.href;
  };

  //**************************** Delete Document ****************************/
  const { loading: deleteLoading, deleteItem } = useDeleteItem();
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [selectedDocumentToDelete, setSelectedDocumentToDelete] =
    useState(null);
  const openDeletePopup = (document) => {
    setSelectedDocumentToDelete(document);
    setShowDeletePopup(true);
  };
  const closeDeletePopup = () => {
    setShowDeletePopup(false);
  };
  const confirmEditCargoX = async (newCargoXData) => {
    const processedData = {
      ...newCargoXData,
      cargoXUploadDate: formatDateUTC(newCargoXData.cargoXUploadDate),
      orderId: Number(orderId), // Convert orderId to number
    };
    const response = await putItem(
      CARGOX_URL,
      processedData,
      `CargoX Edited Successfully!`,
      `Failed To Edit CargoX`
    );
    if (!response) return;
    window.location.reload();
    closeEditCargoxPopup();
  };
  const confirmDelete = async (documentId) => {
    await deleteItem(
      documentId,
      closeDeletePopup,
      DOCUMENTS_URL,
      `Document Deleted Successfully!`,
      `Failed To Delete Document`
    );
    // Update the local documents array by filtering out the deleted document
    const updatedDocuments = documents.filter(
      (doc) => doc.documentId !== documentId
    );
    setDocuments(updatedDocuments);
    window.location.reload();
    closeDeletePopup();
  };
  //**************************** MeatballsMenu Options ****************************/
  const meatballsMenuOptions = (doc) => {
    const cargoX = (initialCargoXs || []).find(
      (c) =>
        c?.cargoXName?.replace(/_/g, " ") ===
        doc?.documentName?.replace(/_/g, " ")
    );

    return [
      {
        label: "Edit Document",
        icon: <EditIcon />,
        color: "primary",
        action: () => onEditDocument(doc),
        showOption: editable,
      },
      // Only include this option if cargoX is found
      ...(cargoX
        ? [
            {
              label: "Edit CargoX",
              icon: <LocalShippingIcon />,
              color: "primary",
              action: () => onEditCargoX(cargoX),
              showOption: editable,
            },
          ]
        : []),
      {
        label: "Delete Document and its associated CargoX",
        icon: <DeleteIcon />,
        color: "error",
        action: () => openDeletePopup(doc),
        showOption: editable && doc.documentName !== "PFI",
      },
    ];
  };

  return (
    <Box sx={{ maxHeight: "85vh", overflowY: "auto" }}>
      {documents.map((doc, idx) => {
        const documentId = doc.objectKey || `${doc.documentName}-${idx}`;
        const isSelected = selectedObject?._docId === documentId;
        // Find the cargoX object whose name matches the document name (ignoring underscores)
        const cargoX =
          (initialCargoXs || []).find(
            (c) =>
              c?.cargoXName?.replace(/_/g, " ") ===
              doc?.documentName?.replace(/_/g, " ")
          ) || {};

        return (
          <>
            <Box
              key={documentId}
              onClick={() => setSelectedObject({ ...doc, _docId: documentId })}
              sx={{
                ...DocumentItemStyles(isSelected),
                position: "relative",
              }}
            >
              {/* Meatballs menu for invoice actions */}
              {editable && (
                <Box
                  sx={{
                    position: "absolute",
                    right: 16,
                    top: 16,
                    zIndex: 2,
                    background: "rgba(255,255,255,0.85)",
                    borderRadius: 2,
                    boxShadow: 1,
                    p: 0.5,
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <MeatballsMenu options={meatballsMenuOptions(doc)} />
                </Box>
              )}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center", // center horizontally
                  alignItems: "center",
                  gap: 2,
                  mb: 0.5,
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 700,
                    fontSize: "1.1rem",
                    color: "primary.main",
                    letterSpacing: 0.5,
                    textAlign: "center", // optional, for multi-line text
                    textDecoration: "underline",
                  }}
                >
                  {doc?.documentName?.replace(/_/g, " ")}
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 600,
                    textDecoration: "underline",
                    color: "text.secondary",
                    fontSize: "1rem",
                  }}
                >
                  Document Details
                </Typography>
              </Box>
              {/* 2. Received date */}
              {doc.softCopyReceivalDate && (
                <Typography variant="caption" color="text.secondary">
                  {doc.documentName != "PFI"
                    ? `Soft Copy Received on: ${new Date(
                        doc.softCopyReceivalDate
                      ).toLocaleDateString()}`
                    : `PFI Received on: ${new Date(
                        doc.softCopyReceivalDate
                      ).toLocaleDateString()}`}
                </Typography>
              )}
              <br />
              {doc.hardCopyReceivalDate && doc.documentName != "PFI" && (
                <Typography variant="caption" color="text.secondary">
                  Hard Copy Received on:{" "}
                  {new Date(doc.hardCopyReceivalDate).toLocaleDateString()}
                </Typography>
              )}
              {doc.comment && doc.documentName != "PFI" && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    mt: 1,
                    flexWrap: "nowrap",
                  }}
                >
                  <CommentIcon sx={{ color: "text.secondary" }} />
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ whiteSpace: "nowrap", flexShrink: 0 }}
                  >
                    Comment:
                  </Typography>
                  <Typography
                    variant="body2"
                    fontStyle="italic"
                    sx={{
                      overflowWrap: "anywhere",
                      flex: 1,
                    }}
                  >
                    {doc.comment}
                  </Typography>
                </Box>
              )}
              {/* 4. Correct/Wrong indicator */}
              {doc.documentName != "PFI" && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mt: 1,
                    gap: 4,
                  }}
                >
                  {/* 1. Correct / Has Issues */}
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    {doc.correct ? (
                      <CheckCircleIcon color="success" fontSize="small" />
                    ) : (
                      <CancelIcon color="error" fontSize="small" />
                    )}
                    <Typography variant="body2" sx={{ ml: 0.5 }}>
                      {doc.correct ? "Correct" : "Has Issues"}
                    </Typography>
                  </Box>

                  {/* 2. Soft Copy Available / Not */}
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    {doc.softCopy ? (
                      <CheckCircleIcon color="success" fontSize="small" />
                    ) : (
                      <CancelIcon color="error" fontSize="small" />
                    )}
                    <Typography variant="body2" sx={{ ml: 0.5 }}>
                      Soft Copy
                    </Typography>
                  </Box>

                  {/* 3. Hard Copy Available / Not */}
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    {doc.hardCopy ? (
                      <CheckCircleIcon color="success" fontSize="small" />
                    ) : (
                      <CancelIcon color="error" fontSize="small" />
                    )}
                    <Typography variant="body2" sx={{ ml: 0.5 }}>
                      Hard Copy
                    </Typography>
                  </Box>
                </Box>
              )}
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 600,
                    textDecoration: "underline",
                    color: "text.secondary",
                    fontSize: "1rem",
                    mt: 1,
                  }}
                >
                  CargoX Details
                </Typography>
              </Box>
              {doc.documentName == "PFI" && (
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 600,
                    mb: 1,
                    mt: 1,
                    color: "text.secondary",
                    textAlign: "center",
                  }}
                >
                  This Document is a PFI and does not have CargoX.
                </Typography>
              )}
              {(!cargoX || Object.keys(cargoX).length === 0) &&
                doc.documentName != "PFI" && (
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontWeight: 600,
                      mb: 1,
                      mt: 1,
                      color: "text.secondary",
                      textAlign: "center",
                    }}
                  >
                    This Document has no associated CargoX.
                  </Typography>
                )}
              {cargoX?.cargoXName && cargoX?.cargoXStatus && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 7,
                    mt: 1,
                  }}
                >
                  <Typography variant="subtitle1">
                    Name: {cargoX?.cargoXName?.replace(/_/g, " ")}
                  </Typography>
                  <Typography variant="subtitle1">
                    State: {cargoX?.cargoXStatus?.replace(/_/g, " ")}
                  </Typography>
                </Box>
              )}
              {cargoX && cargoX?.cargoXUploadDate && (
                <Typography variant="caption" color="text.secondary">
                  Uploaded:{" "}
                  {new Date(cargoX?.cargoXUploadDate).toLocaleDateString()}
                </Typography>
              )}
              {cargoX && cargoX?.comment && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    mt: 1,
                    flexWrap: "nowrap",
                  }}
                >
                  <CommentIcon sx={{ color: "text.secondary" }} />
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ whiteSpace: "nowrap", flexShrink: 0 }}
                  >
                    Comment:
                  </Typography>
                  <Typography
                    variant="body2"
                    fontStyle="italic"
                    sx={{ overflowWrap: "anywhere", flex: 1 }}
                  >
                    {cargoX?.comment}
                  </Typography>
                </Box>
              )}
            </Box>
            <hr />
          </>
        );
      })}
      {cargoXWithoutDoc?.length > 0 &&
        cargoXWithoutDoc.map((cargoX, idx) => {
          const cargoXId = `cargoXWithoutDoc-${idx}`;
          const isSelected = selectedObject?._docId === cargoXId;

          return (
            <>
              <Box
                key={cargoXId}
                onClick={() =>
                  setSelectedObject({ ...cargoX, _docId: cargoXId })
                }
                sx={{
                  ...DocumentItemStyles(isSelected),
                  position: "relative",
                }}
              >
                {editable && (
                  <Box
                    sx={{ position: "absolute", right: 10, top: 10 }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <MeatballsMenu
                      options={[
                        {
                          label: "Edit CargoX",
                          icon: <EditIcon />,
                          color: "primary",
                          action: () => onEditCargoX(cargoX),
                          showOption: editable,
                        },
                      ]}
                    />
                  </Box>
                )}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center", // center horizontally
                    alignItems: "center",
                    gap: 2,
                    mb: 0.5,
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontWeight: 700,
                      fontSize: "1.1rem",
                      color: "primary.main",
                      letterSpacing: 0.5,
                      textAlign: "center", // optional, for multi-line text
                      textDecoration: "underline",
                    }}
                  >
                    {cargoX?.cargoXName?.replace(/_/g, " ")}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontWeight: 600,
                      textDecoration: "underline",
                      color: "text.secondary",
                      fontSize: "1rem",
                    }}
                  >
                    Document Details
                  </Typography>
                </Box>

                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 600,
                    mb: 1,
                    mt: 1,
                    color: "text.secondary",
                    textAlign: "center",
                  }}
                >
                  This CargoX has no associated Document.
                </Typography>

                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontWeight: 600,
                      textDecoration: "underline",
                      color: "text.secondary",
                      fontSize: "1rem",
                      mt: 1,
                    }}
                  >
                    CargoX Details
                  </Typography>
                </Box>

                <Box
                  sx={{ display: "flex", alignItems: "center", gap: 7, mt: 1 }}
                >
                  <Typography variant="subtitle1">
                    State: {cargoX?.cargoXStatus?.replace(/_/g, " ")}
                  </Typography>
                </Box>

                {cargoX?.cargoXUploadDate && (
                  <Typography variant="caption" color="text.secondary">
                    Uploaded:{" "}
                    {new Date(cargoX?.cargoXUploadDate).toLocaleDateString()}
                  </Typography>
                )}

                {cargoX?.comment && (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      mt: 1,
                      flexWrap: "nowrap",
                    }}
                  >
                    <CommentIcon sx={{ color: "text.secondary" }} />
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ whiteSpace: "nowrap", flexShrink: 0 }}
                    >
                      Comment:
                    </Typography>
                    <Typography
                      variant="body2"
                      fontStyle="italic"
                      sx={{ overflowWrap: "anywhere", flex: 1 }}
                    >
                      {cargoX?.comment}
                    </Typography>
                  </Box>
                )}
              </Box>
              <hr />
            </>
          );
        })}

      {EditSectionPopup(
        "Document",
        showEditDocumentPopup,
        closeEditDocumentPopup,
        confirmEditDocument,
        insertDocumentLoading,
        selectedDocument?.documentName != "PFI"
          ? documentformFields
          : PfiFormFields,
        selectedDocument,
        true
      )}
      {EditSectionPopup(
        "CargoX",
        showEditCargoXPopup,
        closeEditCargoxPopup,
        confirmEditCargoX,
        PutItemLoading,
        cargoXformFields,
        selectedCargoX
      )}
      {DeletePopup(
        "Document and its associated CargoX",
        showDeletePopup,
        closeDeletePopup,
        () => confirmDelete(selectedDocumentToDelete?.documentId),
        null,
        deleteLoading
      )}
    </Box>
  );
}
